<template>
  <page-view title>
    <div slot="headerContent">
      <search-robot @changeRobotId="onChangeRobotId"></search-robot>
    </div>
    <div :style="{ marginBottom: '10px' }">
      <demo-video-alert name="DingDanGuanLi"></demo-video-alert>
    </div>
    <exception-page type="norobot" v-if="!currentRobotId" />
    <a-card :bordered="false" v-if="currentRobotId">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="搜索条件">
                <a-select v-model="queryParam.search_condition" placeholder="请选择" allowClear>
                  <a-select-option value="1">订单号</a-select-option>
                  <a-select-option value="2">商品ID</a-select-option>
                  <a-select-option value="3">会员ID</a-select-option>
                  <a-select-option value="4">微信ID</a-select-option>
                  <a-select-option value="5">商品名称</a-select-option>
                  <a-select-option value="6">会员昵称</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="搜索关键字">
                <a-input v-model="queryParam.keywords" placeholder="请输入" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="订单状态">
                <a-select v-model="queryParam.order_condition" placeholder="请选择" allowClear>
                  <a-select-option value="6,7">订单付款</a-select-option>
                  <a-select-option value="8,9,11">订单结算</a-select-option>
                  <a-select-option value="12">订单失效</a-select-option>
                  <a-select-option value="10,13">订单退款</a-select-option>
                  <a-select-option value="-5">订单待付款</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="返利状态">
                  <a-select v-model="queryParam.rebate_condition" placeholder="请选择" allowClear>
                    <a-select-option value="0">未返利</a-select-option>
                    <a-select-option value="1">已返利</a-select-option>
                    <a-select-option value="2">已退款</a-select-option>
                    <a-select-option value="cold">已冻结</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="付款金额小于">
                  <a-input v-model="queryParam.order_pay" placeholder="请输入" />
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
                <a-button style="margin-left: 8px" @click="() => (queryParam = {})">重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operator" v-if="false">
        <a-button
          type="primary"
          :disabled="OrderDownloadStatus.conduct ? true : false"
          @click="$refs.downModal.show(currentRobotId)"
          >同步订单</a-button
        >
        <div style="width: 200px; margin-top: -3px">
          <a-progress
            v-if="OrderDownloadStatus.conduct"
            :percent="OrderDownloadStatus.progress"
            size="small"
            :format="(percent) => parseInt(percent) + '%'"
          />
        </div>
      </div>
      <s-table ref="table" rowKey="id" :scroll="{ x: 2500 }" :columns="columns" :data="loadData">
        <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
        <span slot="order_no" slot-scope="text">
          <a-tooltip placement="top">
            <template slot="title">
              <span>{{ text }}</span>
            </template>
            <span v-line-clamp="1">{{ text }}</span>
          </a-tooltip>
        </span>

        <span slot="item_img" slot-scope="text">
          <a-popover title="商品主图">
            <template slot="content">
              <img :src="text" style="max-width: 200px" />
            </template>
            <a-avatar shape="square" icon="picture" :src="text" />
          </a-popover>
        </span>
        <span slot="order_title" slot-scope="text">
          <a-tooltip placement="top">
            <template slot="title">
              <span>{{ text }}</span>
            </template>
            <a v-line-clamp="1">{{ text }}</a>
          </a-tooltip>
        </span>
        <span slot="user_info" slot-scope="text">
          <a-tooltip placement="left" v-if="text">
            <template slot="title">
              <span>{{ text.nickname }}（uid:{{ text.uid }}）</span>
            </template>
            <span v-line-clamp="1">{{ text.nickname }}</span>
          </a-tooltip>
          <a v-else>未绑定</a>
        </span>
        <span slot="rmb_slot" slot-scope="text">
          <span>{{ text || 0 | currency('￥') }}</span>
        </span>
        <span slot="order_status_slot" slot-scope="text">
          <a-badge v-if="text == '6' || text == '7'" status="processing" text="订单付款" />
          <a-badge v-else-if="text == '8' || text == '9' || text == '11'" status="success" text="订单结算" />
          <a-badge v-else-if="text == '-5' || text == '0'" status="default" text="等待付款" />
          <a-badge v-else status="error" text="订单失效" />
        </span>
        <span slot="total_reward" slot-scope="text">
          <span>{{ text || 0 | currency('￥') }}</span>
        </span>
        <span slot="order_fanli_status_slot" slot-scope="text">
          <span>{{ text | getOrderFanliStatus }}</span>
        </span>
        <span slot="accountdt" slot-scope="text">
          <span>{{ text ? text : '暂未结算' }}</span>
        </span>
        <span slot="createdt" slot-scope="text">
          <span>{{ text ? text : '无创建时间' }}</span>
        </span>
        <span slot="mmpid" slot-scope="text, record">
          <span>{{ record.mmpid }}</span>
        </span>
        <span slot="order_dongjie_status_slot" slot-scope="text">
          <span>
            <a-tag color="red" v-if="text == '1'">已冻结</a-tag>
            <a-tag color="blue" v-else>未冻结</a-tag>
          </span>
        </span>
        <span slot="action" slot-scope="text, record">
          <a-dropdown>
            <a-menu slot="overlay">
              <a-menu-item @click="handleJiesuan(record)" :disabled="record.orderstatus == 8">结算</a-menu-item>
              <a-menu-item @click="handleJiedong(record)" :disabled="record.luckdrawTAG != 1">解冻</a-menu-item>
              <a-menu-item @click="handleJiebang(record)">解绑</a-menu-item>
              <a-menu-item @click="$refs.replaceUidModal.show(record.sub_id, record.id, sourceby)">换绑</a-menu-item>
              <a-menu-item @click="handleTuikuan(record)">退款</a-menu-item>
            </a-menu>
            <a>
              更多
              <a-icon type="down" />
            </a>
          </a-dropdown>
        </span>
      </s-table>
    </a-card>
    <!-- 下载订单 -->
    <down-modal ref="downModal"></down-modal>
    <!-- 换绑 -->
    <replace-uid-modal ref="replaceUidModal" @ok="$refs.table.refresh(true)"></replace-uid-modal>
  </page-view>
</template>

<script>
import { STable } from '@/components'
import SearchRobot from '@/views/components/SearchRobot'
import ReplaceUidModal from '@/views/order/modules/ReplaceUidModal'
import OrderApi from '@/api/order'
import { PageView } from '@/layouts'
import { mapGetters, mapActions } from 'vuex'
import DownModal from './modules/DownModal'
import { DATA_ORDER_STATUS, DATA_ORDER_FANLI_STATUS } from './data'
import { ExceptionPage } from '@/components'
import DemoVideoAlert from '@/views/components/DemoVideoAlert'
const statusMap = {
  1: {
    status: 'processing',
    text: '正常',
  },
  3: {
    status: 'error',
    text: '已过期',
  },
}

export default {
  name: 'OrderPinduoduo',
  components: {
    PageView,
    STable,
    SearchRobot,
    DownModal,
    ExceptionPage,
    ReplaceUidModal,
    DemoVideoAlert,
  },
  data() {
    return {
      sourceby: 2, // 来源
      currentRobotId: null,
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: { search_condition: '1' },
      // 表头
      columns: [
        {
          title: '#',
          width: 50,
          scopedSlots: { customRender: 'serial' },
        },
        {
          title: '机器人ID',
          width: 100,
          dataIndex: 'sub_id',
        },
        {
          title: '订单号',
          width: 200,
          dataIndex: 'orderno',
          scopedSlots: { customRender: 'order_no' },
        },
        {
          title: '主图',
          dataIndex: 'item_img',
          width: 60,
          scopedSlots: { customRender: 'item_img' },
        },
        {
          title: '商品标题',
          width: 200,
          dataIndex: 'title',
          scopedSlots: { customRender: 'order_title' },
        },
        {
          title: '商品ID',
          width: 120,
          dataIndex: 'iid',
        },
        {
          title: '付款金额',
          width: 100,
          dataIndex: 'realprice',
          scopedSlots: { customRender: 'rmb_slot' },
        },
        {
          title: '总佣金',
          width: 100,
          dataIndex: 'tkcommission',
          scopedSlots: { customRender: 'total_reward' },
        },
        {
          title: '认领用户',
          width: 150,
          dataIndex: 'user_info',
          scopedSlots: { customRender: 'user_info' },
        },
        {
          title: '用户奖励',
          width: 100,
          dataIndex: 'fl_user',
          scopedSlots: { customRender: 'rmb_slot' },
        },
        {
          title: '上级奖励',
          width: 100,
          dataIndex: 'fl_agent',
          scopedSlots: { customRender: 'rmb_slot' },
        },
        {
          title: '上上级奖励',
          width: 150,
          dataIndex: 'fl_second',
          sorter: true,
          scopedSlots: { customRender: 'rmb_slot' },
        },
        {
          title: '群主奖励',
          width: 100,
          dataIndex: 'fl_group',
          scopedSlots: { customRender: 'rmb_slot' },
        },
        {
          title: '订单状态',
          width: 120,
          dataIndex: 'orderstatus',
          scopedSlots: { customRender: 'order_status_slot' },
        },
        {
          title: '返利状态',
          width: 100,
          dataIndex: 'flstatus',
          scopedSlots: { customRender: 'order_fanli_status_slot' },
        },
        {
          title: '冻结状态',
          width: 100,
          dataIndex: 'luckdrawTAG',
          scopedSlots: { customRender: 'order_dongjie_status_slot' },
        },
        {
          title: '结算时间',
          width: 200,
          dataIndex: 'accountdt',
          sorter: true,
          scopedSlots: { customRender: 'accountdt' },
        },
        {
          title: '推广位',
          width: 170,
          scopedSlots: { customRender: 'mmpid' },
        },
        {
          title: '创建时间',
          dataIndex: 'createdt',
          scopedSlots: { customRender: 'createdt' },
        },
        // {
        //   title: '操作',
        //   width: '80px',
        //   fixed: 'right',
        //   scopedSlots: { customRender: 'action' },
        // },
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: (parameter) => {
        return OrderApi.getPinduoduoOrderList(
          Object.assign(parameter, this.queryParam, {
            sub_id: this.currentRobotId,
          })
        )
      },
    }
  },
  filters: {
    getOrderStatus(status) {
      const dataObj = DATA_ORDER_STATUS
      if (dataObj[status]) {
        return dataObj[status]['text']
      } else {
        return '未知'
      }
    },
    getOrderFanliStatus(status) {
      const dataObj = DATA_ORDER_FANLI_STATUS
      if (dataObj[status]) {
        return dataObj[status]['text']
      } else {
        return '未知'
      }
    },
  },
  computed: {
    OrderDownloadStatus() {
      const pinduoduoStatus = this.$store.state.order.pinduoduoStatus
      return pinduoduoStatus[this.currentRobotId] ? pinduoduoStatus[this.currentRobotId] : {}
    },
  },
  created() {},
  methods: {
    ...mapActions(['WEBSOCKER_ACTIONS_SENDROBOTMSG', 'demoSetVideo']),
    onChangeRobotId(id) {
      this.currentRobotId = id
      if (this.$refs.table) {
        this.$refs.table.refresh(true)
      }
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    // 结算
    handleJiesuan({ id, sub_id }) {
      const orderid = id
      const robotid = this.currentRobotId
      this.WEBSOCKER_ACTIONS_SENDROBOTMSG({
        robotid: sub_id,
        type: 'operationorder',
        data: {
          orderid: orderid,
          type: '1',
          sourceby: this.sourceby,
        },
      }).then((result) => {
        this.$message.success('发送指令成功')
      })
    },
    // 解冻
    handleJiedong({ id, sub_id }) {
      const orderid = id
      const robotid = this.currentRobotId
      this.WEBSOCKER_ACTIONS_SENDROBOTMSG({
        robotid: sub_id,
        type: 'operationorder',
        data: {
          orderid: orderid,
          type: '2',
          sourceby: this.sourceby,
        },
      }).then((result) => {
        this.$message.success('发送指令成功')
      })
    },
    // 退款
    handleTuikuan({ id, sub_id }) {
      const orderid = id
      const robotid = this.currentRobotId
      this.WEBSOCKER_ACTIONS_SENDROBOTMSG({
        robotid: sub_id,
        type: 'operationorder',
        data: {
          orderid: orderid,
          type: '3',
          sourceby: this.sourceby,
        },
      }).then((result) => {
        this.$message.success('发送指令成功')
      })
    },
    // 解绑
    handleJiebang({ id, sub_id }) {
      const orderid = id + ''
      const robotid = this.currentRobotId
      this.WEBSOCKER_ACTIONS_SENDROBOTMSG({
        robotid: sub_id,
        type: 'operationorder',
        data: {
          orderid: orderid,
          type: '5',
          sourceby: this.sourceby,
        },
      }).then((result) => {
        this.$message.success('发送指令成功')
      })
    },
  },
}
</script>
<style lang="less" scoped>
.table-operator {
  display: flex;
  flex-direction: row;
  align-items: center;
}
/deep/ .page-header {
  .extra {
    display: none;
  }
  .headerContent {
    flex: 0 1 100% !important;
  }
}
</style>
